var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.994 4.06508L10.9011 1.82258C10.1173 1.39508 8.89023 1.39508 8.10648 1.82258L3.97398 4.08008C2.33523 5.13008 2.24023 5.28758 2.24023 6.96008V11.0326C2.24023 12.7051 2.33523 12.8701 4.00565 13.9351L8.09857 16.1776C8.4944 16.3951 9.00107 16.5001 9.49982 16.5001C9.99857 16.5001 10.5052 16.3951 10.8932 16.1776L15.0257 13.9201C16.6644 12.8701 16.7594 12.7126 16.7594 11.0401V6.96008C16.7594 5.28758 16.6644 5.13008 14.994 4.06508ZM9.49982 11.4376C8.08273 11.4376 6.9269 10.3426 6.9269 9.00008C6.9269 7.65758 8.08273 6.56258 9.49982 6.56258C10.9169 6.56258 12.0727 7.65758 12.0727 9.00008C12.0727 10.3426 10.9169 11.4376 9.49982 11.4376Z",
    fill: "#924E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingActive);
export default __webpack_public_path__ + "static/media/setting-active.b95b4cb9922e4df05a7364ba9c3bd27b.svg";
export { ForwardRef as ReactComponent };